import React from 'react'
import { useState } from 'react'
import Header from "./Header"
import Footer from "./Footer";
import { useAuth } from '../context/authContext';
import { useNavigate } from 'react-router-dom'

function Login() {

  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [user, setUser] = useState({
    email: '',
    password: '',
  })

  const handleChange = ({ target: { name, value } }) => {
    setUser({ ...user, [name]: value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await login(user.email, user.password);
      navigate("/cambios");
    } catch (error) {
      alert("Usuario o contraseña incorrectos")
    }
  };


  function miFunc() {
    navigate('/')
  }

  const { login } = useAuth();

  return (
    <div>
      <Header />
      <div className="contenedor__login-register">

        <form action="" className="formulario__login" onSubmit={handleSubmit}>
          <h2>Iniciar Sesión</h2>
          <input type="text" placeholder="Usuario" onChange={handleChange} name="email" />
          <input type="password" placeholder="Contraseña" onChange={handleChange} name="password" />
          <button>Entrar</button>
          <a className="IdBotonVolver" onClick={miFunc}> Volver al menu </a>
        </form>
      </div>
      <Footer />
    </div>

  )
}

export default Login
